import type { Language } from "../i18n";
import { t } from "../i18n";

export type RecognitionMode = "barcode" | "priceTag";

export interface RecognitionModeSwitchProps {
  mode: RecognitionMode;
  onChange: (mode: RecognitionMode) => void;
  language?: Language;
}

export function RecognitionModeSwitch({ mode, onChange, language = "ru" }: RecognitionModeSwitchProps) {
  return (
    <div className="mode-switch" role="tablist" aria-label={t(language, "recognition_mode_aria")}>
      <button
        type="button"
        role="tab"
        aria-selected={mode === "barcode"}
        className={`mode-switch__btn ${mode === "barcode" ? "mode-switch__btn--active" : ""}`}
        onClick={() => onChange("barcode")}
        data-testid="mode-barcode"
      >
        {t(language, "recognition_mode_barcode")}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === "priceTag"}
        className={`mode-switch__btn ${mode === "priceTag" ? "mode-switch__btn--active" : ""}`}
        onClick={() => onChange("priceTag")}
        data-testid="mode-price-tag"
      >
        {t(language, "recognition_mode_price_tag")}
      </button>
    </div>
  );
}
